// ------------------------------------
// Lateral fixa
// ------------------------------------
(function () {
  'use strict';
  if ($('.pag-prod-right').length > 0 && (isMedia('lg') || isMedia('xl'))) {
    let sideTop = 0;
    let headerHeight = 0;
    if ($('.header.fixed').length > 0) {
      headerHeight += $('.header.fixed').outerHeight();
    }
    if ($('.menu-full.fixed').length > 0) {
      headerHeight += $('.menu-full.fixed').outerHeight();
    }
    const sideHeight = $('.pag-prod-right').outerHeight();
    const winHeight = $(window).height();
    const viewHeight = winHeight - headerHeight;
    if (sideHeight < viewHeight) {
      sideTop = headerHeight + 20;
      $('.pag-prod-right').css('top', sideTop);
    } else {
      sideTop = sideHeight - $(window).height() + 10;
      sideTop = -Math.abs(sideTop);
      $('.pag-prod-right').css('top', sideTop);
    }
  }
})();

// ------------------------------------
// Fotos (Carrossel)
// ------------------------------------
(function () {
  'use strict';

  const produtoFotosCarrosel = '#carrosel-produto';
  const $produtoFotosCarrosel = $(produtoFotosCarrosel);
  const produtoThumbsCarrosel = '#carrosel-produto-thumbs';
  const $produtoThumbsCarrosel = $(produtoThumbsCarrosel);
  const produtoFotosQtde = $('.carrosel-produto-foto').length;

  // Configurações carrossel principal
  let produtoFotosCarroselOpt = {
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    swipe: false,
    infinite: true,
    autoplay: false,
    // Responsivo
    responsive: [
      // Tablet
      {
        breakpoint: 960,
        settings: {
          fade: false,
          swipe: true,
        },
      },
      // Mobile
      {
        breakpoint: 480,
        settings: {
          fade: false,
          swipe: true,
          arrows: false,
        },
      },
    ],
  };

  // Configurações carrossel thumbs
  let produtoThumbsCarroselOpt = {
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    arrows: false,
    focusOnSelect: true,
    infinite: false,
    asNavFor: produtoFotosCarrosel,
    // Responsivo
    responsive: [
      // Tablet
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false,
        },
      },
      // Mobile
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false,
        },
      },
    ],
  };

  if ((isMedia('sm') || isMedia('xs')) && produtoFotosQtde > 4) {
    produtoFotosCarroselOpt.asNavFor = produtoThumbsCarrosel;
    produtoThumbsCarroselOpt.infinite = true;
  }

  // Carrosel Principal
  $produtoFotosCarrosel.slick(produtoFotosCarroselOpt);

  // Carrosel Thumbs
  $produtoThumbsCarrosel.slick(produtoThumbsCarroselOpt);

  // Ao clicar na thumb do vídeo é ancorado para a seção do vídeo
  $('.video-anchor').on('click', function (ev) {
    ev.preventDefault();
    smoothScroll('#video-sec');
  });
})();

// ------------------------------------
// Zoom
// ------------------------------------
function initProdDetZoom() {
  if ($('.produto-fotos').hasClass('enable-zoom') && (isMedia('xl') || isMedia('lg'))) {
    $('.produto-fotos').addClass('zoom-loaded');
    $('.carrosel-produto-foto').each(function () {
      const $el = $(this);
      const imgLg = $(this).data('img-lg');
      $el.zoom({
        url: imgLg,
        magnify: 0.75,
      });
    });
  }
}
function destroyProdDetZoom() {
  if ($('.produto-fotos').length > 0) {
    $('.carrosel-produto-foto').each(function () {
      const $el = $(this);
      $el.trigger('zoom.destroy');
    });
  }
}
if ($('.produto-fotos').length > 0) {
  $('.produto-fotos').on('mouseenter', function () {
    if (!$('.produto-fotos').hasClass('zoom-loaded')) {
      initProdDetZoom();
    }
  });
  $(window).on(
    'hresize ',
    debounce(function () {
      destroyProdDetZoom();
      initProdDetZoom();
    }, 100),
  );
}

// ------------------------------------
// Lightbox
// ------------------------------------
(function () {
  'use strict';
  const $images = $('[data-lightbox]');
  if ($images.length > 0) {
    const lightboxCfg = {
      navText: ['', ''],
      closeText: '',
      captionPosition: 'outside',
      fileExt: false,
      heightRatio: 0.8,
      captionSelector: 'self',
      captionType: 'data',
      history: false,
    };
    const lightbox = $images.simpleLightbox(lightboxCfg);
    $('.produto-fotos-zoom-alert').on('click', function () {
      lightbox.open();
    });
  }
})();

// ------------------------------------
// Pessoas comprando no momento
// ------------------------------------
let pBuyCurTimer;
function initpBuyCur() {
  let interval = 15; // Intervalo em segundos
  interval = interval * 1000;
  if (pBuyCurTimer !== undefined) {
    clearInterval(pBuyCurTimer);
  }
  const $el = $('.produto-comprando .md-text');
  if ($el.length > 0) {
    let htmlText = $el.html();
    htmlText = htmlText.replace(/{.*}/g, '<span>' + getRandomNumber() + '</span>');
    $el.html(htmlText);
    pBuyCurTimer = setInterval(() => {
      $el.html($el.html().replace(/<span>.*<\/span>/g, '<span>' + getRandomNumber() + '</span>'));
    }, interval);
    function getRandomNumber() {
      return randomNumber(6, 12);
    }
  }
}
initpBuyCur();

// ------------------------------------
// Quantidade em estoque (Gatilho)
// ------------------------------------
function initStockView() {
  const $el = $('.produto-estoque');
  if ($el.length > 0) {
    const estoqueTipo = $el.data('estoque-tipo');
    const estoqueReal = $el.data('estoque-real');
    const estoqueFicticio = $el.data('estoque-ficticio');
    const estoqueView = estoqueTipo == 'real' ? estoqueReal : estoqueFicticio;
    let htmlText = $el.find('.md-text').html();
    htmlText = htmlText.replace(/{.*}/g, '<span>' + estoqueView + '</span>');
    htmlText = htmlText.replace(/<span>.*<\/span>/g, '<span>' + estoqueView + '</span>');
    $el.find('.md-text').html(htmlText);
  }
}
initStockView();

// ------------------------------------
// Variantes e atributos
// ------------------------------------
(function () {
  'use strict';
  const $variants = $('[data-variants]');
  if ($('.pag-produto').length > 0) {
    const variants = $variants.data('variants');
    const $priceOld = $('.prod-preco-old, .popup-buy-price-old');
    const $price = $('.prod-preco-new');
    const $quantity = $('.produto-det-quantidade #quantity');
    const $btnBuy = $('#btn-buy');
    const $alertStock = $('.produto-det-indisponivel');
    const $variant = $('#variant');
    const $installmentsInfos = $('.prod-preco-parc');
    const installments = $installmentsInfos.data('installments') ? Number($installmentsInfos.data('installments')) : 0;
    const installmentsFree = $installmentsInfos.data('installments-free')
      ? Number($installmentsInfos.data('installments-free'))
      : 0;
    const installmentsFee = $installmentsInfos.data('installments-fee')
      ? Number($installmentsInfos.data('installments-fee'))
      : 0;
    const gateway = $installmentsInfos.data('installments-gateway')
      ? $installmentsInfos.data('installments-gateway')
      : '';
    let variant;

    $('.produto-det-atributo .attr-radio, .produto-det-atributo .attr-select').on('change', function () {
      getAttrVariant();
    });
    $('body').on('recalc-parc', function () {
      getAttrVariant();
    });

    // Retorna o slug da variante com base nos atributos selecionados
    function getAttrVariant() {
      let variantSlug = [];
      $('.produto-det-atributo .attr-radio:checked, .produto-det-atributo .attr-select').each(function () {
        const $input = $(this);
        const attrName = $input.attr('name');
        const attrValue = slugify($input.val());
        const $optValue = $('[data-opt-value="' + attrName + '"]');
        let optTitle;
        if ($input.hasClass('attr-radio')) {
          optTitle = $input.data('title');
        } else if ($input.hasClass('attr-select')) {
          optTitle = $input.find('option:selected').data('title');
        }
        if (optTitle) {
          $optValue.text(optTitle);
        } else {
          $optValue.text('');
        }
        variantSlug.push(attrName + ':' + attrValue);
      });
      variantSlug = variantSlug.join('|');
      showVariantInfos(variantSlug ? variantSlug : 'u');
    }

    function showInstallmentsInfos(listaParcelas) {
      if (installments > 0 && listaParcelas.length > 0) {
        let lastParcela = listaParcelas.slice(-1)[0];
        populaParcelas(listaParcelas, variant.sale_price);
        if(Number(variant.sale_price) > Number($('#infos-base').data('minpaypalparc'))){
          if (lastParcela) {
            const semJuros = lastParcela.sem_juros ? ' SEM JUROS' : '';
            const initTxt = lastParcela.sem_juros ? 'em' : 'em';
            const parcTxt = `${initTxt} <b>${lastParcela.num_parcela}x</b> ${semJuros} de <b>R$ ${formatMoneyBR(
              lastParcela.valor_parcela,
            )}</b>`;
            $installmentsInfos.html(parcTxt);
            $('.popup-buy-price-parc').html(parcTxt);
            $installmentsInfos.show();
          }
        }
      }
    }

    // Exibe as informações da variante selecionada
    function showVariantInfos(variantSlug) {
      variant = getVariant(variantSlug);
      if (variant !== undefined) {
        //console.log(variant);
        console.log('Variante: ' + variant.sku);
        window.curVariant = variant;
        window.curVariant.product_title = $('.prod-title').text();

        // Frete
        $('#cart-zipcode').data('peso', variant.weight);
        $('#cart-zipcode').data('comprimento', variant.length);
        $('#cart-zipcode').data('altura', variant.height);
        $('#cart-zipcode').data('largura', variant.width);

        // Seta a variante no botão
        $btnBuy.data('variant', variant.sku);

        // SKU
        $variant.val(variant.sku);
        if ($('.prod-sku').length) {
          $('.prod-sku').text('SKU: ' + variant.sku);
        }

        // Foca a imagem
        if (variant.image_id != '') {
          focusSlideImage(variant.image_id);
        }

        // Valor customização
        const customVal = window.customAddVal ? Number(window.customAddVal) : 0;
        if (variant.sale_price_bkp === undefined) {
          variant.sale_price_bkp = variant.sale_price;
        }
        if (variant.old_price_bkp === undefined) {
          variant.old_price_bkp = variant.old_price;
        }
        variant.sale_price = Number(variant.sale_price_bkp) + customVal;
        variant.old_price = Number(variant.old_price_bkp) + customVal;

        // Preço antigo
        $priceOld.hide();
        if (Number(variant.old_price) > 0) {
          $priceOld.html('R$ ' + formatMoneyBR(Number(variant.old_price)));
          $priceOld.show();
        }

        // Preço atual
        console.log(variant.sale_price);
        if (variant.sale_price == 0) {
          $('.prod-consulte').show();
          $('.prod-precos').hide();
          $('.produto-det-qtde-btn').hide();
          $('.caixa-frete').hide();
        }
        $price.html('R$ ' + formatMoneyBR(Number(variant.sale_price)/*  + customVal */));
        $('.v-price').text('R$ ' + formatMoneyBR(Number(variant.sale_price)/*  + customVal */));

        // Calcula e exibe as informações de parcelamento
        $installmentsInfos.hide();
        if (installments > 1) {
          let listaParcelas = [];
          // Mercado Pago
          if (gateway === 'mercadopago') {
            //listaParcelas = gerarParcelasMP(Number(variant.sale_price), installments, installmentsFree);
            //showInstallmentsInfos(listaParcelas);
            getMercadoPagoInstallments(Number(variant.sale_price), installments, showInstallmentsInfos);
          }
          // Appmax, Pagar.me, Cloudfox
          else if (gateway === 'appmax' || gateway === 'pagarme' || gateway === 'cloudfox' || gateway === 'doppus') {
            listaParcelas = gerarParcelas(Number(variant.sale_price), installments, installmentsFree, installmentsFee);
            showInstallmentsInfos(listaParcelas);
          }
          // Demais
          else {
            listaParcelas = gerarParcelas(Number(variant.sale_price), installments, installmentsFree, installmentsFee);
            showInstallmentsInfos(listaParcelas);
          }
        }

        // Descontos
        $('.prod-preco-discount').hide();
        $('.prod-preco-economia').hide();
        $('.prod-preco-economia-pix').hide();
        if (Number(variant.old_price) > 0) {
          let discountPercent = 100 - (Number(variant.sale_price) * 100) / Number(variant.old_price);
          discountPercent = parseInt(discountPercent);
          let discountPriceDiff = Number(variant.old_price) - Number(variant.sale_price);
          if (discountPercent > 0) {
            if ($('.prod-preco-discount').length > 0) {
              $('.prod-preco-discount').text(discountPercent + '% Off');
              $('.prod-preco-discount').show();
            }
            if ($('.prod-preco-economia').length > 0) {
              $('.prod-preco-economia').text('Economia de R$ ' + formatMoneyBR(discountPriceDiff));
              $('.prod-preco-economia').show();
            }
          }
        }

        // Descontos
        $('[data-discount]').each(function () {
          const $discount = $(this);
          const $discountPrice = $discount.find('.discount-price');
          const $discountPercent = $discount.find('.discount-percent');
          const discountPercent = $discount.data('discount') ? Number($discount.data('discount')) : 0;
          const discountPrice = (discountPercent * Number(variant.sale_price)) / 100;
          const newPrice = Number(variant.sale_price) - discountPrice;
          $discountPrice.text('R$ ' + formatMoneyBR(newPrice));
          $discountPercent.text('+' + formataDesconto(discountPercent) + '% Off');
          const method = $discount.data('discount-method');
          const $viewPrice = $('.v-price-' + method);
          if ($viewPrice.length > 0) {
            $viewPrice.text('R$ ' + formatMoneyBR(newPrice));
          }
          if (method === 'pix') {
            $('.prod-preco-economia-pix').text('Economia de R$ ' + formatMoneyBR(variant.old_price - newPrice));
          }
          $discount.show();
        });

        // Quantidade
        if (variant.automatic_stock == '1') {
          if (variant.quantity > 0) {
            $quantity.attr('max', variant.quantity);
          } else {
            $quantity.attr('max', 1);
          }
        } else {
          $quantity.removeAttr('max');
        }
        $quantity.val(1);
        initSpinners();
        $('.produto-estoque').data('estoque-real', variant.quantity);
        initStockView();

        // Botão compra
        if (variant.automatic_stock == '1' && variant.quantity == 0) {
          $alertStock.show();
          $btnBuy.prop('disabled', true);
        } else {
          $alertStock.hide();
          $btnBuy.prop('disabled', false);
        }
      }
    }
    $('body').on('upd-var-info', function () {
      if (curVariant) {
        showVariantInfos(curVariant.slug);
      }
    });

    // Retorna uma variante com base no slug
    function getVariant(variantSlug) {
      return variants.filter((item) => item.slug == variantSlug)[0];
    }

    // Foca a imagem da variante no carrossel de fotos
    function focusSlideImage(imageID) {
      const $imageSlide = $('#carrosel-produto .carousel-item[data-image="' + imageID + '"]');
      if ($imageSlide.length > 0) {
        const imageIndex = $imageSlide.data('slick-index');
        if ($('#carrosel-produto').hasClass('slick-initialized')) {
          $('#carrosel-produto').slick('slickGoTo', imageIndex);
        }
      }
    }

    // Pré-seleciona a primeira variante disponível
    preSelectVariant();
    function preSelectVariant() {
      let variant = variants.filter((item) => {
        return item.automatic_stock == '0' || (item.automatic_stock == '1' && item.quantity > 0);
      })[0];
      if (variant !== undefined) {
        if (variant.slug === 'u') {
          showVariantInfos('u');
        } else {
          const variantArr = variant.slug.split('|');
          variantArr.forEach((item) => {
            const optArr = item.split(':');
            const optName = optArr[0];
            const optValue = optArr[1];
            let $select = $(`.produto-det-atributo .attr-select[name="${optName}"]`);
            let $radio = $(`.produto-det-atributo .attr-radio[name="${optName}"][value="${optValue}"]`);
            if ($select.length > 0) {
              $select.val(optValue).trigger('change');
            } else if ($radio.length > 0) {
              $radio.prop('checked', true).trigger('change');
            }
          });
        }
      } else {
        variant = variants[0];
        if (variant) {
          showVariantInfos(variant.slug);
        }
      }
    }

    // Popula a lista dos parcelamentos no modal
    function populaParcelas(parcelas,sale_variant) {
      const $listaParcelas = $('#modal-det-pagamento .installments-list');
      $listaParcelas.html('');
      if(Number(sale_variant) > Number($('#infos-base').data('minpaypalparc'))){
        parcelas.forEach((parcela) => {
          const semJuros = parcela.sem_juros ? ' sem juros' : '';
          $listaParcelas.append(`
          <li class="installments-list-item">
            <span class="installments-list-item-left"><b>${parcela.num_parcela}x</b> de <b>R$ ${formatMoneyBR(
                  parcela.valor_parcela,
                )}</b>${semJuros}</span>
            <span class="installments-list-item-right">Total: <b>R$ ${formatMoneyBR(parcela.valor_total)}</b></span>
          </li>`);
        });
      }else{
        
        parcelas.forEach((parcela) => {
          const semJuros = parcela.sem_juros ? ' sem juros' : '';
          if(parcela.num_parcela > 1){
            return false;
          }
          $listaParcelas.append(`
          <li class="installments-list-item">
            <span class="installments-list-item-left"><b>${parcela.num_parcela}x</b> de <b>R$ ${formatMoneyBR(
                  parcela.valor_parcela,
                )}</b>${semJuros}</span>
            <span class="installments-list-item-right">Total: <b>R$ ${formatMoneyBR(parcela.valor_total)}</b></span>
          </li>`);
        });
      }
    }
  }
})();

// ------------------------------------
// Adiciona no carrinho
// ------------------------------------

// Ao clicar no botão para adicionar no carrinho
$('#btn-buy').on('click', function (ev) {
  ev.preventDefault();
  if (!previewMode) {
    const variant = $(this).data('variant');
    if (validateCustomizations()) {
      addToCart(variant);
    }
  }
});

// Ao alterar customização
$('.produto-det-custom-item .form-input').on('change', function (ev) {
  const $input = $(this);
  let customVal = 0;
  if ($input.val() != '') {
    customVal = $input.data('c-price') || 0;
  }
  window.customAddVal = customVal;
  $('body').trigger('upd-var-info');
});

/* $('#btn-buy').on('click', function (ev) {
  ev.preventDefault();
  if (!previewMode) {
    const variant = $(this).data('variant');
    if (validateCustomizations()) {
      addToCart(variant);
    }
  }
}); */

function addToCart(variant, isKit = false) {
  const urlCart = urlBase + 'store/core/acoes/checkout/cart.php';
  let type;
  let kitID = 0;
  let productId = 0;
  let productURL = '';
  let kitOptSKU = '';
  let productPrice = 0;
  let productsList = [];
  let quantity = 0;
  let productQuantity = 1;
  let modalCartShow = false;
  let skipCart = false;
  let conta = $('#btn-buy').data('product-conta');
  let prazoEntrega = $('#btn-buy').data('product-prazo-entrega');

  // Verifica se o modal será exibido ou será redirecionado
  if ($('#btn-buy').data('show-modal-cart')) {
    modalCartShow = true;
  }

  // Verifica se a opção de pular carrinho está habilitada
  if ($('#btn-buy').data('skip-cart')) {
    skipCart = true;
  }

  // Produto padrão
  if (!isKit) {
    type = 'default';
    quantity = $('#quantity').val();
    productId = $('#btn-buy').data('product-id');
    productURL = $('#btn-buy').data('product-url');
    productsList.push({
      product_id: productId,
      product_url: productURL,
      variant: variant,
      quantity: quantity,
    });
  }
  /* // Kit antigo
  else if (isKit == 1) {
    type = 'kit_old';
    quantity = 1;
    productId = baseProduct;
    productsList.push({
      product_id: baseProduct,
      product_url: baseProductURL,
      variant: variant,
      quantity: quantity,
    });
  }
  // Kit novo
  else if (isKit == 2) {
    type = 'kit_new';
    kitID = variant.kit_id;
    productId = baseProduct;
    kitOptSKU = variant.sku; // SKU da opção do kit
    productQuantity = 1;
    productsList = variant.variants.map((vItem) => {
      return {
        product_id: baseProduct,
        product_url: baseProductURL,
        variant: vItem.variant_sku,
        quantity: vItem.quantity,
      };
    });
  } */
  const data = {
    store_token: publicToken,
    lp_url: urlBaseLp,
    type: type,
    kit_id: kitID,
    kit_opt_sku: kitOptSKU,
    products: productsList,
    lp_id: baseLanding,
    product_id: productId,
    quantity: productQuantity,
    conta: conta,
    prazo_entrega: prazoEntrega,
  };

  // Customizações
  if ($('#btn-buy').data('customizations')) {
    data.customizations = JSON.parse($('#btn-buy').data('customizations'));
  }

  showLoader();
  $.getJSON(urlCart, data, function (result) {
    console.log(result);
    if (result.status === 'success') {
      dispatchPixelEvent('facebook', 'AddToCart');
      dispatchAddToCartAnalytics();
      dispatchAddToCartPinterest();
      dispatchAddToCartTiktok();
      dispatchAddToCartKwai();
      if (skipCart) {
        setTimeout(() => {
          location.href = result.checkout_url;
        }, 2000);
      } else {
        if (modalCartShow) {
          let cartUrl = result.checkout_url.split('/');
          const cartToken = cartUrl[cartUrl.length - 1];
          if (cartToken) {
            getCart(cartToken);
          }
          hideLoader();
          modalOpen('modal-cart');
        } else {
          setTimeout(() => {
            location.href = urlBase + 'cart';
          }, 2000);
        }
      }
    } else {
      hideLoader();
      showAlert('Erro', 'Não foi possível realizar esta operação.', 'danger');
    }
  }).fail(function (qXHR, textStatus, errorThrown) {
    console.log(qXHR);
    hideLoader();
    showAlert('Erro', 'Não foi possível realizar esta operação.', 'danger');
  });
}

// Verifica as customizações preenchidas
function validateCustomizations() {
  let customObj = [];
  const $btnBuy = $('#btn-buy');
  if ($('.produto-det-custom').length > 0) {
    let numInvalid = 0;
    $('.produto-det-custom-item .form-input').each(function () {
      const $input = $(this);
      $input.parsley().validate();
      if (!$input.parsley().isValid()) {
        numInvalid++;
      } else if ($input.val() != '') {
        customObj.push({
          customization_id: $input.data('c-id'),
          title: $input.data('c-title'),
          value: $input.val(),
          price_add: $input.data('c-price'),
        });
      }
    });
    if (numInvalid > 0) {
      return false;
    }
    if (customObj.length > 0) {
      console.log(customObj);
      customObj = JSON.stringify(customObj);
      $btnBuy.data('customizations', customObj);
    }
  }
  return true;
}

// ------------------------------------
// Mercado Pago
// ------------------------------------

// Inicia o Mercado Pago
$('body').on('mp-loaded', function () {
  if (typeof Mercadopago != 'undefined') {
    getMercadoPagoToken(function () {
      $('body').trigger('recalc-parc');
      if ($('.prod-preco-parc').length > 0) {
        $('.prod-preco-parc').trigger('recalc');
      }
    });
  }
});

// Obtém o token
function getMercadoPagoToken(callback = false) {
  const mpTokenApp = $('#external-js').data('mp-token');
  if (mpTokenApp) {
    Mercadopago.setPublishableKey(mpTokenApp);
    if (typeof callback === 'function') {
      callback();
    }
  } else {
    const urlSession = urlBase + 'store/core/acoes/checkout/mercadopago_get_session.php';
    $.getJSON(`${urlSession}?store_token=${publicToken}`, function (result) {
      // console.log(result);
      Mercadopago.setPublishableKey(result.mp_token);
      if (typeof callback === 'function') {
        callback();
      }
    }).fail(function (result) {
      console.log('Não foi possível obter o token do Mercado Pago.');
      console.log(result);
    });
  }
}

// Obtém as parcelas do cartão
function getMercadoPagoInstallments(amount, parcelas, callback = false) {
  parcelas = !parcelas ? 1 : parcelas;
  const cardBin = 555566;
  if (typeof Mercadopago != 'undefined') {
    Mercadopago.getInstallments(
      {
        bin: cardBin,
        amount: parseFloat(amount),
      },
      function (status, response) {
        if (status == 200) {
          //console.log(response);
          let installments = response[0].payer_costs;
          // Formata as parcelas para o formato utilizado
          let newInstallments = [];
          let countParc = 0;
          installments.forEach((item) => {
            if (countParc < parcelas) {
              countParc++;
              newInstallments.push({
                num_parcela: item.installments,
                valor_total: item.total_amount,
                sem_juros: item.installment_rate === 0,
                valor_parcela: item.installment_amount,
              });
            }
          });
          //console.log(newInstallments);
          if (callback !== false) {
            callback(newInstallments);
          }
        } else {
          console.log('Não foi possível obter as parcelas do Mercado Pago.');
        }
      },
    );
  }
}

// Popup Mobile
(function () {
  'use strict';

  // Variáveis
  const $popupBuy = $('.popup-buy');
  const $popupBuyBtn = $popupBuy.find('.popup-buy-btn .btn');

  // Click no botão de compra
  $popupBuyBtn.on('click', function (ev) {
    const variant = $('#variant').val();
    if (variant != '') {
      $('#btn-buy').trigger('click');
    } else {
      smoothScroll('.prod-precos');
    }
  });

  // Exibe ou oculta o popup com base no scroll
  $(window).on('scroll', debounce(handleViewPopupBuy, 25));
  handleViewPopupBuy();
  function handleViewPopupBuy() {
    if ($('#btn-buy').length > 0) {
      const topOfElement = $('#btn-buy').offset().top;
      const bottomOfElement = $('#btn-buy').offset().top + $('#btn-buy').outerHeight();
      const bottomOfScreen = $(window).scrollTop() + $(window).innerHeight();
      const topOfScreen = $(window).scrollTop();
      if (topOfScreen < bottomOfElement) {
        $popupBuy.removeClass('active');
      } else {
        $popupBuy.addClass('active');
      }
    }
  }
})();
